exports.dev = {
  host: 'localhost',
  port: 23217,

  // 开发模式下 API 请求的后端地址
  apiHost: 'http://172.18.153.123:22080',
}

exports.prod = {
  // apiHost: '/',
  publicUrl: `/`, // 资源请求的公共路径
  cssTag: 'app-sdwan-css',
}

// domain对应的api映射表
// domain:匹配的域名
// apiHost: 请求url
// publicUrl: 文件目录（仅做声明，没有用到）
const domainList = [
  // jh27测试环境
  {
    domain: 'jh27-sdwan.console.baishan.com',
    apiHost: '//jh27-sdwan-api.console.baishan.com',
    publicUrl: `/`
  },
  // canvas预发布环境
  {
    domain: 'sdwan-canvas-pre.console.baishan.com',
    apiHost: '//sdwan-canvas-pre.api.baishan.com'
  },
  // canvas正式环境
  {
    domain: 'home.console.baishan.com',
    apiHost: '//sdwan-api.sxnsp.com',
    publicUrl: '//sdwan.console.baishan.com'
  },
  // 独立部署预发布环境
  {
    domain: 'sdwan-pro-pre.console.baishan.com',
    apiHost: '//sdwan-pro-pre.api.baishan.com'
  },
  // 独立部署正式环境
  {
    domain: 'sdwan-pro.sxnsp.com',
    apiHost: '//sdwan-pro-api.sxnsp.com',
    publicUrl: `/`
  },
  // A&S融合测试环境
  {
    domain: 'test-as.console.baishan.com',
    apiHost: 'http://test-as-api.console.baishan.com',
    publicUrl: `//test-as.console.baishan.com/sdwan/`
  },
  // A&S融合预发布环境
  {
    domain: 'sdwan-as-pre.console.baishan.com',
    apiHost: '//sdwan-as-pre.api.baishan.com'
  },
  // A&S融合正式环境
  {
    domain: 'sdwan-as.sxnsp.com',
    apiHost: '//sdwan-as-api.sxnsp.com',
    publicUrl: `//sdwan-as.sxnsp.com/sdwan/`
  },
  // channel预发布环境
  {
    domain: 'sdwan-channel-pre.console.baishan.com',
    apiHost: '//sdwan-channel-pre.api.baishan.com'
  }
]

// 传入当前域名domain,协议protocol
exports.getApiHost = (domain, protocol) => {
  const findItem = domainList.find((i) => i.domain === domain)
  return findItem ? findItem.apiHost : `${protocol}//${domain}`
}
